export class ApplicationError extends Error {

    public httpStatus?: number = 404;
    public applicationStatus?: number;
    public errorMessageTranslationkey: string;
    public handled: boolean = false;

    constructor(message?: string) {
        super(message);
        this.name = ApplicationError.name;
        Object.setPrototypeOf(this, ApplicationError.prototype);
    }
}
